import { Component, inject } from '@angular/core';
import { FileDataStore } from '../../../../store/file-data.store';
import { GridOptions } from 'ag-grid-community';
import { DatePipe } from '@angular/common';
import { AgPaginatorComponent } from '../../../ag-grid-components/ag-paginator/ag-paginator.component';
import { DownloadIconRendererComponent } from '../../../ag-grid-components/download-icon-renderer/download-icon-renderer.component';
import { AgGridModule } from 'ag-grid-angular';

@Component({
  selector: 'app-my-exports-grid',
  imports: [AgGridModule],
  providers: [DatePipe],
  templateUrl: './my-exports-grid.component.html',
  styleUrl: './my-exports-grid.component.scss',
})
export class MyExportsGridComponent {
  readonly store = inject(FileDataStore);
  readonly datePipe = inject(DatePipe);
  readonly mode = 'myExports';
  
  gridOptions: GridOptions = {
    defaultColDef: {
      suppressMovable: true,
      suppressHeaderMenuButton: true
    },
    columnDefs: [
      {
        field: "rowToken",
        hide: true
      },
      {
        field: "createDateTime",
        headerName: "Create Date/Time",
        flex: 1,
        valueFormatter: (params) => {
          return this.datePipe.transform(params.data?.createDateTime, "MM/dd/yyyy hh:mm a") ?? "";
        }
      },
      {
        field: "exportType",
        headerName: "Export Type",
        flex: 1
      },
      {
        field: "fileName",
        headerName: "File Name",
        flex: 3
      },
      {
        field: "action",
        headerName: "Action",
        minWidth: 84,
        maxWidth: 84,
        cellRenderer: "downloadRenderer",
        sortable: false,
      }
    ],
    statusBar: {
      statusPanels: [
        {
          statusPanel: AgPaginatorComponent,
          key: "ag-paginator"
        },
      ],
    },
    paginationPageSize: 25,
    paginationPageSizeSelector: [25,50],
  };

  gridComponents = {
    downloadRenderer: DownloadIconRendererComponent,
  };

  onDownloadClicked(rowToken: string) {
    this.store.downloadFile(rowToken, this.mode);
  }

  onPaginatorPageSizeChange(pageSize: number) {
    this.gridOptions.paginationPageSize = pageSize;
  }
}
